<template>
</template>
<script>
export default {
  name: 'WeniChat',
  props: {
    url: {
      required: true
    }
  },
  created() {
    this.start()
  },
  methods: {
    start(){
      if(!this.url || !this.url.includes('weni-sp-integrations')){
        this.mostrarNotificacaoErro('A url do chat não está configurada corretamente.')
        return;
      }
      (function (d, s, u) {
        let h = d.getElementsByTagName(s)[0], k = d.createElement(s);
        k.onload = function () {
          let l = d.createElement(s); l.src = u; l.async = true;
          h.parentNode.insertBefore(l, k.nextSibling);
        };
        k.async = true; k.src = 'https://storage.googleapis.com/push-webchat/wwc-latest.js';
        h.parentNode.insertBefore(k, h);
      })(document, 'script', this.url);
    }
  }
}
</script>
<style lang="stylus">
.push-widget-container
  padding-bottom 50px !important
  padding-right 2px !important

.push-chat-open.push-full-screen
  padding 0 !important
</style>
